import React from 'react';
import {useLocalization} from 'localization';
import type {ActionButtonProps} from './types';
import {ActionButton} from './ActionButton';

type Props = Omit<
  ActionButtonProps,
  'title' | 'background' | 'showSpinnerOnClick'
> &
  Partial<Pick<ActionButtonProps, 'title'>>;

export const DeleteButton: React.FC<Props> = ({title, ...props}) => {
  const {t} = useLocalization();
  const resolvedTitle = title ?? t('general.delete');
  return (
    <ActionButton
      title={resolvedTitle}
      icon="Delete"
      showSpinnerOnClick
      {...props}
    />
  );
};
